<script lang="ts">
	import type { PageData } from './$types';
	import SellerForm from '../component/SellerForm.svelte';

	export let data: PageData;
</script>

<SellerForm {data} isEdit={false} />
